import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/use-id.ts
import { useCallback, useId as useReactId, useMemo, useState } from "react";
function useId(idProp, prefix) {
  var id = useReactId();
  return useMemo(function () {
    return idProp || [prefix, id].filter(Boolean).join("-");
  }, [idProp, prefix, id]);
}
function useIds(idProp) {
  for (var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    prefixes[_key - 1] = arguments[_key];
  }
  var id = useId(idProp);
  return useMemo(function () {
    return prefixes.map(function (prefix) {
      return "".concat(prefix, "-").concat(id);
    });
  }, [id, prefixes]);
}
function useOptionalPart(partId) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  var ref = useCallback(function (node) {
    setId(node ? partId : null);
  }, [partId]);
  return {
    ref: ref,
    id: id,
    isRendered: Boolean(id)
  };
}
export { useId, useIds, useOptionalPart };